import { Box, Divider, Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

export const ReviewDetailsWrapper = ({heading, value, children, divider=true}) => {
  return (
    <>
    <Box sx={{display:"flex", alignItems:"stretch", gap: 2, mb: 3 }}>
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 500,
          border: "1px solid #1A407D",
          borderRadius: "8px",
          padding: "10px 25px",
          color: "#1A407D",
          alignItems: "center",
        }}
      >
        {heading}
      </Typography>
      {value && (
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 500,
          border: "1px solid #1A407D",
          background: "#1A407D",
          borderRadius: "8px",
          padding: "10px 25px",
          color: "#FAFAFA",
          alignItems: "center",
        }}
      >
        {value}
      </Typography>
      )}
    </Box>
      <Grid container rowSpacing={2} columnSpacing={10}>
      {children}
      </Grid>

      {divider && <Divider sx={{border:"1px dashed #DADADA", mt:2, mb:3}}/>}
      </>
  );
};



ReviewDetailsWrapper.propTypes = {
  children: PropTypes.any,
  divider: PropTypes.any,
  heading: PropTypes.any,
  value: PropTypes.any,
};
